import { render, staticRenderFns } from "./TechSkills.vue?vue&type=template&id=23c26561&scoped=true"
import script from "./TechSkills.vue?vue&type=script&lang=js"
export * from "./TechSkills.vue?vue&type=script&lang=js"
import style0 from "./TechSkills.vue?vue&type=style&index=0&id=23c26561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c26561",
  null
  
)

export default component.exports